export enum DeleteFlagEnum {
  SINGLE_DELETE = 'SINGLE_DELETE',
  MULTIPLE_DELETE = 'MULTIPLE_DELETE',
}

export enum SortEnum {
  DESC_NAME = 'DESC_NAME',
  ASC_NAME = 'ASC_NAME',
  DESC_UPDATED = 'DESC_UPDATED',
  ASC_UPDATED = 'ASC_UPDATED',
  DESC_CREATED = 'DESC_CREATED',
  ASC_CREATED = 'ASC_CREATED',
}

export enum SortOperation {
  DESC = 'DESC',
  ASC = 'ASC',
}

export const DEFAULT_CLIENT_TAG_SKIP = 0
export const DEFAULT_CLIENT_TAG_LIMIT = 15
